import Tesseract from "tesseract.js";

export interface OcrResult {
  text: string;
  confidence: number;
}

/**
 * Extract text from a canvas element or a region of it
 */
export async function extractTextFromCanvas(
  canvas: HTMLCanvasElement,
  region?: { x: number; y: number; width: number; height: number }
): Promise<OcrResult> {
  let imageData: string;

  if (region) {
    const { x, y, width, height } = region;
    const offscreen = document.createElement("canvas");
    offscreen.width = width;
    offscreen.height = height;
    const ctx = offscreen.getContext("2d");
    if (!ctx) throw new Error("Failed to create canvas context");
    ctx.drawImage(canvas, x, y, width, height, 0, 0, width, height);
    imageData = offscreen.toDataURL("image/png");
  } else {
    imageData = canvas.toDataURL("image/png");
  }

  const result = await Tesseract.recognize(imageData, "eng", {
    logger: () => {},
  });

  return {
    text: result.data.text.trim(),
    confidence: result.data.confidence,
  };
}
